export const replacePlaceholdersMixin = {
  methods: {
    // @vuese
    // Zamienia placeholdery na właściwe teksty
    replacePlaceholders(text, lowercase) {
      const reg = /\$\{(\w+)\}/;
      for (let captured = reg.exec(text); !!captured; captured = reg.exec(text)) {
        captured = captured[1];
        text = text.replace(new RegExp('\\$\\{' + captured + '\\}', 'g'), this.getReplacement(captured, lowercase));
      }
      return text;
    },

    // @vuese
    // Zwraca zamiennik dla znalezionego placeholdera
    getReplacement(captured, lowercase) {
      if (this[captured]) {
        return lowercase ? this[captured].toLowerCase() : this[captured];
      }
      return '';
    }
  }
};
